import { createFeatureSelector, createSelector } from "@ngrx/store";

import * as fromFittings from '../reducers/fittings.reducer';
import * as fromUserProfile from '../reducers/user-profile.reducer';

const fittingsState = createFeatureSelector<fromFittings.State>(fromFittings.fittingsFeatureKey);
const userProfileState = createFeatureSelector<fromUserProfile.State>(fromUserProfile.userProfileFeatureKey);

export const selectShowModalLoader = createSelector(fittingsState, userProfileState,
  (fittings, user) =>
    user.loaders.includes(fromUserProfile.Loaders.loadingUserProfile) ||
    user.loaders.includes(fromUserProfile.Loaders.loadingMenu)
)
